import { Component, ChangeDetectionStrategy, ViewChild, AfterViewInit, OnDestroy, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { ɵobserve as observe } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { AsyncPipe, NgFor } from '@angular/common';

interface RadioProps extends FormlyFieldProps {
  labelPosition?: 'before' | 'after';
}

export interface FormlyRadioFieldConfig extends FormlyFieldConfig<RadioProps> {
  type: 'mat-radio' | Type<MatRadioTypeComponent>;
}

@Component({
  selector: 'mat-radio-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  imports: [NgFor, MatIconModule, FormlyModule,  MatRadioModule,  ReactiveFormsModule, MatFormFieldModule, FormlySelectModule, AsyncPipe],
  template: `
    @if (formState.editMode) {
    <mat-radio-group
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="required"
      [tabindex]="props.tabindex"
    >
      <mat-radio-button
        *ngFor="let option of props.options | formlySelectOptions : field | async; let i = index"
        [id]="id + '_' + i"
        [color]="props.color"
        [labelPosition]="props.labelPosition"
        [disabled]="option.disabled"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-radio-button>
    </mat-radio-group>
    }@else{
    <div class="max-w-full flex flex-row items-center space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400 ">
        <mat-icon class="mr-2" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
        <span class="">{{getValue()}}</span>
    </div>
    }
  `,
})
export class MatRadioTypeComponent extends FieldType<FieldTypeConfig<RadioProps>> implements AfterViewInit, OnDestroy {
  @ViewChild(MatRadioGroup, { static: false }) radioGroup!: MatRadioGroup;
  override defaultOptions = {
    props: {
      hideFieldUnderline: true,
      floatLabel: 'always' as const,
      tabindex: -1,
    },
  };

  private focusObserver!: ReturnType<typeof observe>;
  ngAfterViewInit() {
    this.focusObserver = observe(this.field, ['focus'], ({ currentValue }) => {
      if (this.props.tabindex === -1 && currentValue && this.radioGroup._radios.length > 0) {
        // https://github.com/ngx-formly/ngx-formly/issues/2498
        setTimeout(() => {
          const radio = this.radioGroup.selected ? this.radioGroup.selected : this.radioGroup._radios.first;
          radio.focus();
        });
      }
    });
  }

  getValue(): string {

    const value = this.formControl.value
    const options = this.props.options as Array<any>

    if (options) {
      return options.filter((x: any) => String(x.value) == String(value))[0]?.label
    }
    else {
      return value
    }
}


  // TODO: find a solution to prevent scroll on focus
  override onContainerClick() {}

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.focusObserver && this.focusObserver.unsubscribe();
  }
}
